import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const ChangeHistory = ({ changeHistory }) => {
  const [isHistoryCollapsed, setIsHistoryCollapsed] = useState(true);
  const { t } = useTranslation();

  return (
    <div className="bg-gray-50 p-3 rounded-lg dark:bg-gray-800">
      <div className="flex items-center gap-2">
        <button
          onClick={() => setIsHistoryCollapsed(!isHistoryCollapsed)}
          className="flex items-center gap-2 text-gray-500 hover:text-gray-700 w-full dark:text-gray-400 dark:hover:text-gray-200"
        >
          <span>{isHistoryCollapsed ? "+" : "-"}</span>
          <h3 className="text-base font-semibold">
            {t(
              "vehicleProfile.changeHistory.title",
              "Change History (last 10)"
            )}
          </h3>
        </button>
      </div>

      {!isHistoryCollapsed && (
        <div className="mt-3 w-full dark:bg-gray-700 dark:border-gray-600">
          {changeHistory.length === 0 ? (
            <p className="text-sm dark:text-gray-400">
              {t("vehicleProfile.changeHistory.noChanges", "No changes yet.")}
            </p>
          ) : (
            <div className="font-mono text-xs dark:text-gray-400 w-full">
              {changeHistory.map((change, idx) => (
                <div
                  key={idx}
                  className="border-l-4 border-l-blue-200 mb-2 bg-gray-50 rounded-bl-md p-2 dark:bg-gray-700 dark:border-gray-600 w-full"
                >
                  <div className="flex-grow w-full">
                    <p className="text-sm break-all whitespace-pre-wrap">
                      <strong>
                        {t(
                          `vehicleProfile.fields.${change.field}`,
                          change.field
                        )}
                        :
                      </strong>{" "}
                      {JSON.stringify(change.oldValue)} →{" "}
                      {JSON.stringify(change.newValue)}
                    </p>
                    <div className="text-xs text-gray-500 mt-0.5">
                      {change.user?.username ||
                        t("common.anonymous", "Anonymous")}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ChangeHistory;
